// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__vlNYe","noInteraction":"EventWrapper_noInteraction__3gMLk","pointerPassthrough":"EventWrapper_pointerPassthrough__2A3J2"};